/*
 * Copyright (c) 2024. Haodong JU
 */

import hillo from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { VSelect } from 'vuetify/lib/components'
import { uniqBy } from 'lodash'
import { storageNewApiHost } from '@/model/dataLayer/api/storage/inventoryUtils'

export async function getAllListByName (name) {
  const deviceId = await getCurrentDeviceId()
  return await hillo.get(storageNewApiHost + name + '/list/' + deviceId, {
    shop: '/shops/' + deviceId,
    shopId: deviceId
  })
}

export async function saveByName (name, data) {
  return await hillo.jsonPost(storageNewApiHost + name + '/save', {
    ...data,
    shopId: await getCurrentDeviceId()
  })
}

export async function deleteByName (name, id) {
  const deviceId = await getCurrentDeviceId()
  return await hillo.jsonPost(storageNewApiHost + name + '/delete/' + id, {
    shop: '/shops/' + deviceId,
    shopId: deviceId
  })
}

export async function getResourceList (categoryId = null) {
  const deviceId = await getCurrentDeviceId()
  return await hillo.get(storageNewApiHost + 'resource/listByShopId/' + deviceId +
    (categoryId ? '/' + categoryId : ''), {})
}

export async function getCategorySchema (
  defaultParentId,
  selfId = null,
  required = true
) {
  const res = (await getAllListByName('resourceCategory')).map(it => treeToList(it, 'categories'))
  let categoryList = [...res.flat()]
  if (selfId) {
    const self = treeToList(categoryList.find(it => it.id === selfId),
      'categories').map(it => it.id)
    categoryList = categoryList
      .filter(it => !self.includes(it.id))
  }
  return {
    key: 'parentId',
    name: 'SubHeadings',
    component: VSelect,
    required,
    default: defaultParentId,
    componentProps: {
      items: categoryList.map(it => {
        it.text = it.name
        it.value = it.id
        return it
      })
    }
  }
}

export function treeToList (tree, childKey, nodes = []) {
  if (tree[childKey]?.length > 0) {
    nodes.push(tree)
    tree[childKey].forEach(it => {
      it.parentId = tree.id
      treeToList(it, childKey, nodes)
    })
  } else {
    nodes.push(tree)
  }
  return uniqBy(nodes, 'id')
}
